var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25561",
    "data-name": "Group 25561",
    transform: "translate(-64 -420)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(64 420)",
    fill: "#60be79"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25559",
    "data-name": "Group 25559",
    transform: "translate(0.665 0.356)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x2: 1.383,
    y2: 1.39,
    transform: "translate(66 424.898)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    y2: 4.649,
    transform: "translate(70.671 423) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.732b8c6ca7189d12ae9d8c67a453017d.svg";
export { ForwardRef as ReactComponent };